export default __webpack_public_path__ + "static/piercing-story-2-4f7240bc466053d8b4ba95332ce98f70.jpg";